import Revelar from './Revelar';
import styles from './LandingBase.module.css';

const FreeTrial = ({ onClick = () => {} }) => {
  return (
    <section id="comecar" className={styles.section}>
      <Revelar>
        <div className={styles.ctaBanner}>
          <h2 className={styles.ctaTitle}>Comece a enxergar suas finanças</h2>
          <p className={styles.ctaText}>
            Reúna contas, cartões e gastos num só lugar, veja a projeção do mês e saiba pra onde vai seu dinheiro. Sem planilha, em
            poucos minutos.
          </p>
          <button className={styles.btnWhite} onClick={onClick}>
            Criar conta grátis
          </button>
        </div>
      </Revelar>
    </section>
  );
};

export default FreeTrial;
